import HeaderLangSelector from '../layout/HeaderLangSelector';

export default {
  props: ['langSelector'],
  components: {
    HeaderLangSelector,
  },
};



// WEBPACK FOOTER //
// ./src/mixins/lang-selector.js